import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { MdOutlineLightbulb } from 'react-icons/md'; // Actionable Recommendations
import { MdOutlineTrendingUp } from 'react-icons/md';
import img1 from "../../../../assets/img/Services/AI&ML/2150377156.jpg";

export default function MainSection4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Prescriptive Analytics
            </h1>
            <p className="text-lg text-gray-600">
            Gain actionable recommendations to optimize business processes and decision-making.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineLightbulb className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Actionable Recommendations</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Leverage data insights to identify the best strategies for optimizing business operations.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineTrendingUp className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">  Improved Decision-Making</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Utilize prescriptive models to evaluate scenarios and select the most effective course of action.
              </p>
            </div>

      
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}